<template>
  <el-dialog
    v-bind="$attrs"
    :top="top"
    :close-on-click-modal="closeOnClickModal"
    :show-close="showClose"
    append-to-body
    :close-on-press-escape="closeOnPressEscape"
    :width="width"
  >
    <div slot="title">
      <slot name="title">
        <div class="title" :style="`background:${titleBg}`">
          {{ title }}
        </div>
      </slot>
    </div>

    <div v-if="maxHeight" :style="style">
      <el-scrollbar :vertical="true" :max-height="maxHeight" style="height:100%">
        <div>
          <slot />
        </div>
      </el-scrollbar>
    </div>
    <div v-else :style="style">
      <slot />
    </div>
    <div slot="footer" :class="[footerClass[footerPosition], 'dialog-footer', dialogFooter]">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'CustomDialog',
  props: {
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: undefined
    },
    top: {
      type: String,
      default: '7vh'
    },
    title: {
      type: String,
      default: ''
    },
    footerPosition: {
      type: String,
      default: 'center'
    },
    dialogFooter: {
      type: String,
      default: 'center'
    },
    width: {
      type: String,
      default: '585px'
    },
    titleBg: {
      type: String,
      default: '#F1F6FF'
    }
  },
  data() {
    return {
      footerClass: {
        'center': 'footer-center',
        'left': 'footer-left',
        'right': 'footer-right'
      }
    }
  },
  computed: {
    style() {
      const style = {}
      if (!this.fullscreen) {
        if (this.maxHeight) {
          style.height = this.maxHeight
        }
      }
      return style
    }
  }
}
</script>
<style lang="scss">
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-select-dropdown .el-scrollbar {
  padding-bottom: 17px;
}
.footer-center {
  display: flex;
  justify-content: center;
}
.footer-left{
  display: flex;
  justify-content: left;
}
</style>
<style lang="scss" scoped>
@import "~@/styles/element.scss";
::v-deep .el-dialog__header {
  // background-color: #F3F4F8;
  padding: 0px;
}
::v-deep .el-dialog__body{
  padding-bottom: 0!important;
}
::v-deep .el-dialog__close{
  background: #D8E0EF;
  border-radius: 50%;
  padding: 1px;
  color: #fff;
}
.dialog-footer{
  margin-bottom: 14px;
}
.title{
  height: 48px;
  padding: 0 20px;
  line-height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.scrollbar-dialog__title {
  @include list(row);
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
  padding-left: 10px;
  box-sizing: border-box;
  h3:first-child {
    position: relative;
    &:after{
      content: " ";
      width: 1px;
      height: 20px;
      display: block;
      position: absolute;
      left: -12px;
      top: 2px;
      border-right: 6px solid #1890ff;
    }
  }
}
</style>

